<template>
  <div class="pay-status-back">
    {{ $t("payAdv.status") }}
  </div>
</template>

<script>
export default {
  name: "Status"
};
</script>

<style scoped>
.pay-status-back {
  height: 100%;
  min-height: 100vh;
  box-sizing: border-box;
  background: #1F3A43;
  color: white;
  display: flex;
  justify-content: center;
  padding-top: 150px;
  font-size: 58px;
}
</style>
